// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/project_permits.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type {
  DenormalizedClient,
  DenormalizedClientJson,
  DenormalizedJobType,
  DenormalizedJobTypeJson,
  DenormalizedProject,
  DenormalizedProjectJob,
  DenormalizedProjectJobJson,
  DenormalizedProjectJson,
  DenormalizedUser,
  DenormalizedUserJson,
} from './denormalized_pb';
import { file_proto_v1_denormalized } from './denormalized_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  ProjectJobPermitType,
  ProjectJobPermitTypeJson,
} from './project_jobs_pb';
import { file_proto_v1_project_jobs } from './project_jobs_pb';
import type { ProjectTaxLocation, ProjectTaxLocationJson } from './projects_pb';
import { file_proto_v1_projects } from './projects_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  DateRange,
  DateRangeJson,
  Pagination,
  PaginationJson,
  ProjectJobType,
  ProjectJobTypeJson,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/project_permits.proto.
 */
export const file_proto_v1_project_permits: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_denormalized,
      file_proto_v1_extension_enum,
      file_proto_v1_project_jobs,
      file_proto_v1_projects,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitPayment
 */
export type ProjectJobPermitPayment =
  Message<'vmspdb.api.proto.v1.ProjectJobPermitPayment'> & {
    /**
     * @generated from field: bool paid = 1;
     */
    paid: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp payment_date = 2;
     */
    paymentDate?: Timestamp;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitPayment
 */
export type ProjectJobPermitPaymentJson = {
  /**
   * @generated from field: bool paid = 1;
   */
  paid?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 2;
   */
  paymentDate?: TimestampJson;
};

export type ProjectJobPermitPaymentValid = ProjectJobPermitPayment;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobPermitPayment.
 * Use `create(ProjectJobPermitPaymentSchema)` to create a new message.
 */
export const ProjectJobPermitPaymentSchema: GenMessage<
  ProjectJobPermitPayment,
  {
    jsonType: ProjectJobPermitPaymentJson;
    validType: ProjectJobPermitPaymentValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 0);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitSubmission
 */
export type ProjectJobPermitSubmission =
  Message<'vmspdb.api.proto.v1.ProjectJobPermitSubmission'> & {
    /**
     * @generated from field: bool submitted = 1;
     */
    submitted: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp submit_date = 2;
     */
    submitDate?: Timestamp;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitSubmission
 */
export type ProjectJobPermitSubmissionJson = {
  /**
   * @generated from field: bool submitted = 1;
   */
  submitted?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp submit_date = 2;
   */
  submitDate?: TimestampJson;
};

export type ProjectJobPermitSubmissionValid = ProjectJobPermitSubmission;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobPermitSubmission.
 * Use `create(ProjectJobPermitSubmissionSchema)` to create a new message.
 */
export const ProjectJobPermitSubmissionSchema: GenMessage<
  ProjectJobPermitSubmission,
  {
    jsonType: ProjectJobPermitSubmissionJson;
    validType: ProjectJobPermitSubmissionValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 1);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitMilestone
 */
export type ProjectJobPermitMilestone =
  Message<'vmspdb.api.proto.v1.ProjectJobPermitMilestone'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitStatus status = 1;
     */
    status: ProjectJobPermitStatus;

    /**
     * @generated from field: google.protobuf.Timestamp date = 2;
     */
    date?: Timestamp;

    /**
     * @generated from field: string notes = 3;
     */
    notes: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectJobPermitMilestone
 */
export type ProjectJobPermitMilestoneJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitStatus status = 1;
   */
  status?: ProjectJobPermitStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp date = 2;
   */
  date?: TimestampJson;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

export type ProjectJobPermitMilestoneValid = ProjectJobPermitMilestone;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectJobPermitMilestone.
 * Use `create(ProjectJobPermitMilestoneSchema)` to create a new message.
 */
export const ProjectJobPermitMilestoneSchema: GenMessage<
  ProjectJobPermitMilestone,
  {
    jsonType: ProjectJobPermitMilestoneJson;
    validType: ProjectJobPermitMilestoneValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized
 */
export type ProjectPermitTaskServiceDenormalized =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
     */
    project?: DenormalizedProject;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 2;
     */
    projectJob?: DenormalizedProjectJob;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedClient contractor_client = 3;
     */
    contractorClient?: DenormalizedClient;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectTaxLocation tax_location = 4;
     */
    taxLocation: ProjectTaxLocation;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_managers = 5;
     */
    projectManagers: DenormalizedUser[];

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_job_managers = 6;
     */
    projectJobManagers: DenormalizedUser[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized
 */
export type ProjectPermitTaskServiceDenormalizedJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
   */
  project?: DenormalizedProjectJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 2;
   */
  projectJob?: DenormalizedProjectJobJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedClient contractor_client = 3;
   */
  contractorClient?: DenormalizedClientJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectTaxLocation tax_location = 4;
   */
  taxLocation?: ProjectTaxLocationJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_managers = 5;
   */
  projectManagers?: DenormalizedUserJson[];

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser project_job_managers = 6;
   */
  projectJobManagers?: DenormalizedUserJson[];
};

export type ProjectPermitTaskServiceDenormalizedValid =
  ProjectPermitTaskServiceDenormalized;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized.
 * Use `create(ProjectPermitTaskServiceDenormalizedSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceDenormalizedSchema: GenMessage<
  ProjectPermitTaskServiceDenormalized,
  {
    jsonType: ProjectPermitTaskServiceDenormalizedJson;
    validType: ProjectPermitTaskServiceDenormalizedValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse
 */
export type ProjectPermitTaskServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
     */
    estimatedPickupDate?: Timestamp;

    /**
     * @generated from field: string notes = 4;
     */
    notes: string;

    /**
     * @generated from field: double client_cost = 5;
     */
    clientCost: number;

    /**
     * @generated from field: double review_fees = 6;
     */
    reviewFees: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
     */
    type: ProjectJobPermitType;

    /**
     * @generated from field: string project_job_uuid = 8;
     */
    projectJobUuid: string;

    /**
     * @generated from field: string project_uuid = 9;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
     */
    milestones: ProjectJobPermitMilestone[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
     * @deprecated
     */
    jobType: ProjectJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
     */
    payment?: ProjectJobPermitPayment;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
     */
    submission?: ProjectJobPermitSubmission;

    /**
     * @generated from field: double service_fee = 14;
     */
    serviceFee: number;

    /**
     * @generated from field: string contractor_client_uuid = 15;
     */
    contractorClientUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
     */
    jobTypeV2?: DenormalizedJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectPermitTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse
 */
export type ProjectPermitTaskServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
   */
  estimatedPickupDate?: TimestampJson;

  /**
   * @generated from field: string notes = 4;
   */
  notes?: string;

  /**
   * @generated from field: double client_cost = 5;
   */
  clientCost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double review_fees = 6;
   */
  reviewFees?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
   */
  type?: ProjectJobPermitTypeJson;

  /**
   * @generated from field: string project_job_uuid = 8;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: string project_uuid = 9;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
   */
  milestones?: ProjectJobPermitMilestoneJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
   * @deprecated
   */
  jobType?: ProjectJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
   */
  payment?: ProjectJobPermitPaymentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
   */
  submission?: ProjectJobPermitSubmissionJson;

  /**
   * @generated from field: double service_fee = 14;
   */
  serviceFee?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: string contractor_client_uuid = 15;
   */
  contractorClientUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
   */
  jobTypeV2?: DenormalizedJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectPermitTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectPermitTaskServiceCreateResponseValid =
  ProjectPermitTaskServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse.
 * Use `create(ProjectPermitTaskServiceCreateResponseSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceCreateResponseSchema: GenMessage<
  ProjectPermitTaskServiceCreateResponse,
  {
    jsonType: ProjectPermitTaskServiceCreateResponseJson;
    validType: ProjectPermitTaskServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest
 */
export type ProjectPermitTaskServiceGetRequest =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest
 */
export type ProjectPermitTaskServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest
 */
export type ProjectPermitTaskServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetRequest.
 * Use `create(ProjectPermitTaskServiceGetRequestSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceGetRequestSchema: GenMessage<
  ProjectPermitTaskServiceGetRequest,
  {
    jsonType: ProjectPermitTaskServiceGetRequestJson;
    validType: ProjectPermitTaskServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 5);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetResponse
 */
export type ProjectPermitTaskServiceGetResponse =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
     */
    estimatedPickupDate?: Timestamp;

    /**
     * @generated from field: string notes = 4;
     */
    notes: string;

    /**
     * @generated from field: double client_cost = 5;
     */
    clientCost: number;

    /**
     * @generated from field: double review_fees = 6;
     */
    reviewFees: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
     */
    type: ProjectJobPermitType;

    /**
     * @generated from field: string project_job_uuid = 8;
     */
    projectJobUuid: string;

    /**
     * @generated from field: string project_uuid = 9;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
     */
    milestones: ProjectJobPermitMilestone[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
     * @deprecated
     */
    jobType: ProjectJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
     */
    payment?: ProjectJobPermitPayment;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
     */
    submission?: ProjectJobPermitSubmission;

    /**
     * @generated from field: double service_fee = 14;
     */
    serviceFee: number;

    /**
     * @generated from field: string contractor_client_uuid = 15;
     */
    contractorClientUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
     */
    jobTypeV2?: DenormalizedJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectPermitTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetResponse
 */
export type ProjectPermitTaskServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
   */
  estimatedPickupDate?: TimestampJson;

  /**
   * @generated from field: string notes = 4;
   */
  notes?: string;

  /**
   * @generated from field: double client_cost = 5;
   */
  clientCost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double review_fees = 6;
   */
  reviewFees?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
   */
  type?: ProjectJobPermitTypeJson;

  /**
   * @generated from field: string project_job_uuid = 8;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: string project_uuid = 9;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
   */
  milestones?: ProjectJobPermitMilestoneJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
   * @deprecated
   */
  jobType?: ProjectJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
   */
  payment?: ProjectJobPermitPaymentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
   */
  submission?: ProjectJobPermitSubmissionJson;

  /**
   * @generated from field: double service_fee = 14;
   */
  serviceFee?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: string contractor_client_uuid = 15;
   */
  contractorClientUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
   */
  jobTypeV2?: DenormalizedJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectPermitTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectPermitTaskServiceGetResponseValid =
  ProjectPermitTaskServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceGetResponse.
 * Use `create(ProjectPermitTaskServiceGetResponseSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceGetResponseSchema: GenMessage<
  ProjectPermitTaskServiceGetResponse,
  {
    jsonType: ProjectPermitTaskServiceGetResponseJson;
    validType: ProjectPermitTaskServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 6);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest
 */
export type ProjectPermitTaskServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
     */
    estimatedPickupDate?: Timestamp;

    /**
     * @generated from field: string notes = 4;
     */
    notes: string;

    /**
     * @generated from field: double review_fees = 6;
     */
    reviewFees: number;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
     */
    milestones: ProjectJobPermitMilestone[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
     */
    payment?: ProjectJobPermitPayment;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
     */
    submission?: ProjectJobPermitSubmission;

    /**
     * @generated from field: double service_fee = 14;
     */
    serviceFee: number;

    /**
     * @generated from field: string contractor_client_uuid = 15;
     */
    contractorClientUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest
 */
export type ProjectPermitTaskServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
   */
  estimatedPickupDate?: TimestampJson;

  /**
   * @generated from field: string notes = 4;
   */
  notes?: string;

  /**
   * @generated from field: double review_fees = 6;
   */
  reviewFees?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
   */
  milestones?: ProjectJobPermitMilestoneJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
   */
  payment?: ProjectJobPermitPaymentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
   */
  submission?: ProjectJobPermitSubmissionJson;

  /**
   * @generated from field: double service_fee = 14;
   */
  serviceFee?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: string contractor_client_uuid = 15;
   */
  contractorClientUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest
 */
export type ProjectPermitTaskServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
     */
    estimatedPickupDate?: Timestamp;

    /**
     * @generated from field: string notes = 4;
     */
    notes: string;

    /**
     * @generated from field: double review_fees = 6;
     */
    reviewFees: number;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
     */
    milestones: ProjectJobPermitMilestoneValid[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
     */
    payment?: ProjectJobPermitPaymentValid;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
     */
    submission?: ProjectJobPermitSubmissionValid;

    /**
     * @generated from field: double service_fee = 14;
     */
    serviceFee: number;

    /**
     * @generated from field: string contractor_client_uuid = 15;
     */
    contractorClientUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateRequest.
 * Use `create(ProjectPermitTaskServiceUpdateRequestSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceUpdateRequestSchema: GenMessage<
  ProjectPermitTaskServiceUpdateRequest,
  {
    jsonType: ProjectPermitTaskServiceUpdateRequestJson;
    validType: ProjectPermitTaskServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 7);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateResponse
 */
export type ProjectPermitTaskServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
     */
    estimatedPickupDate?: Timestamp;

    /**
     * @generated from field: string notes = 4;
     */
    notes: string;

    /**
     * @generated from field: double client_cost = 5;
     */
    clientCost: number;

    /**
     * @generated from field: double review_fees = 6;
     */
    reviewFees: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
     */
    type: ProjectJobPermitType;

    /**
     * @generated from field: string project_job_uuid = 8;
     */
    projectJobUuid: string;

    /**
     * @generated from field: string project_uuid = 9;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
     */
    milestones: ProjectJobPermitMilestone[];

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
     * @deprecated
     */
    jobType: ProjectJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
     */
    payment?: ProjectJobPermitPayment;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
     */
    submission?: ProjectJobPermitSubmission;

    /**
     * @generated from field: double service_fee = 14;
     */
    serviceFee: number;

    /**
     * @generated from field: string contractor_client_uuid = 15;
     */
    contractorClientUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
     */
    jobTypeV2?: DenormalizedJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectPermitTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateResponse
 */
export type ProjectPermitTaskServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_pickup_date = 3;
   */
  estimatedPickupDate?: TimestampJson;

  /**
   * @generated from field: string notes = 4;
   */
  notes?: string;

  /**
   * @generated from field: double client_cost = 5;
   */
  clientCost?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: double review_fees = 6;
   */
  reviewFees?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitType type = 7;
   */
  type?: ProjectJobPermitTypeJson;

  /**
   * @generated from field: string project_job_uuid = 8;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: string project_uuid = 9;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectJobPermitMilestone milestones = 10;
   */
  milestones?: ProjectJobPermitMilestoneJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType job_type = 11 [deprecated = true];
   * @deprecated
   */
  jobType?: ProjectJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitPayment payment = 12;
   */
  payment?: ProjectJobPermitPaymentJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitSubmission submission = 13;
   */
  submission?: ProjectJobPermitSubmissionJson;

  /**
   * @generated from field: double service_fee = 14;
   */
  serviceFee?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: string contractor_client_uuid = 15;
   */
  contractorClientUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type_v2 = 16;
   */
  jobTypeV2?: DenormalizedJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectPermitTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectPermitTaskServiceUpdateResponseValid =
  ProjectPermitTaskServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceUpdateResponse.
 * Use `create(ProjectPermitTaskServiceUpdateResponseSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceUpdateResponseSchema: GenMessage<
  ProjectPermitTaskServiceUpdateResponse,
  {
    jsonType: ProjectPermitTaskServiceUpdateResponseJson;
    validType: ProjectPermitTaskServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceListRequest
 */
export type ProjectPermitTaskServiceListRequest =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.PermitSort sort = 8;
     */
    sort: PermitSort;

    /**
     * @generated from field: string employee = 6 [deprecated = true];
     * @deprecated
     */
    employee: string;

    /**
     * @generated from field: string project = 7 [deprecated = true];
     * @deprecated
     */
    project: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
     */
    dateRange?: DateRange;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitFilterStatus status = 10;
     */
    status: ProjectJobPermitFilterStatus;

    /**
     * @generated from field: string project_uuid = 11;
     */
    projectUuid: string;

    /**
     * @generated from field: string project_job_uuid = 12;
     */
    projectJobUuid: string;

    /**
     * @generated from field: string employee_uuid = 13;
     */
    employeeUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceListRequest
 */
export type ProjectPermitTaskServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.PermitSort sort = 8;
   */
  sort?: PermitSortJson;

  /**
   * @generated from field: string employee = 6 [deprecated = true];
   * @deprecated
   */
  employee?: string;

  /**
   * @generated from field: string project = 7 [deprecated = true];
   * @deprecated
   */
  project?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
   */
  dateRange?: DateRangeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobPermitFilterStatus status = 10;
   */
  status?: ProjectJobPermitFilterStatusJson;

  /**
   * @generated from field: string project_uuid = 11;
   */
  projectUuid?: string;

  /**
   * @generated from field: string project_job_uuid = 12;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: string employee_uuid = 13;
   */
  employeeUuid?: string;
};

export type ProjectPermitTaskServiceListRequestValid =
  ProjectPermitTaskServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceListRequest.
 * Use `create(ProjectPermitTaskServiceListRequestSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceListRequestSchema: GenMessage<
  ProjectPermitTaskServiceListRequest,
  {
    jsonType: ProjectPermitTaskServiceListRequestJson;
    validType: ProjectPermitTaskServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceListResponse
 */
export type ProjectPermitTaskServiceListResponse =
  Message<'vmspdb.api.proto.v1.ProjectPermitTaskServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse items = 1;
     */
    items: ProjectPermitTaskServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitTaskServiceListResponse
 */
export type ProjectPermitTaskServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectPermitTaskServiceCreateResponse items = 1;
   */
  items?: ProjectPermitTaskServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type ProjectPermitTaskServiceListResponseValid =
  ProjectPermitTaskServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitTaskServiceListResponse.
 * Use `create(ProjectPermitTaskServiceListResponseSchema)` to create a new message.
 */
export const ProjectPermitTaskServiceListResponseSchema: GenMessage<
  ProjectPermitTaskServiceListResponse,
  {
    jsonType: ProjectPermitTaskServiceListResponseJson;
    validType: ProjectPermitTaskServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_permits, 10);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitStatus
 */
export enum ProjectJobPermitStatus {
  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_STATUS_RECEIVED = 2;
   */
  RECEIVED = 2,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_STATUS_DENIED = 3;
   */
  DENIED = 3,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_STATUS_SENT_TO_CLIENT = 4;
   */
  SENT_TO_CLIENT = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitStatus
 */
export type ProjectJobPermitStatusJson =
  | 'PROJECT_JOB_PERMIT_STATUS_UNSPECIFIED'
  | 'PROJECT_JOB_PERMIT_STATUS_AVAILABLE'
  | 'PROJECT_JOB_PERMIT_STATUS_RECEIVED'
  | 'PROJECT_JOB_PERMIT_STATUS_DENIED'
  | 'PROJECT_JOB_PERMIT_STATUS_SENT_TO_CLIENT';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobPermitStatus.
 */
export const ProjectJobPermitStatusSchema: GenEnum<
  ProjectJobPermitStatus,
  ProjectJobPermitStatusJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_project_permits, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitFilterStatus
 */
export enum ProjectJobPermitFilterStatus {
  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_FILTER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_FILTER_STATUS_CURRENT = 1;
   */
  CURRENT = 1,

  /**
   * @generated from enum value: PROJECT_JOB_PERMIT_FILTER_STATUS_SENT_TO_CLIENT = 2;
   */
  SENT_TO_CLIENT = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ProjectJobPermitFilterStatus
 */
export type ProjectJobPermitFilterStatusJson =
  | 'PROJECT_JOB_PERMIT_FILTER_STATUS_UNSPECIFIED'
  | 'PROJECT_JOB_PERMIT_FILTER_STATUS_CURRENT'
  | 'PROJECT_JOB_PERMIT_FILTER_STATUS_SENT_TO_CLIENT';

/**
 * Describes the enum vmspdb.api.proto.v1.ProjectJobPermitFilterStatus.
 */
export const ProjectJobPermitFilterStatusSchema: GenEnum<
  ProjectJobPermitFilterStatus,
  ProjectJobPermitFilterStatusJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_project_permits, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.PermitSort
 */
export enum PermitSort {
  /**
   * @generated from enum value: PERMIT_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMIT_SORT_PAYMENT_STATUS = 1;
   */
  PAYMENT_STATUS = 1,

  /**
   * @generated from enum value: PERMIT_SORT_NOTES = 2;
   */
  NOTES = 2,

  /**
   * @generated from enum value: PERMIT_SORT_PERMIT_STATUS = 3;
   */
  PERMIT_STATUS = 3,

  /**
   * @generated from enum value: PERMIT_SORT_SUBMIT_STATUS = 4;
   */
  SUBMIT_STATUS = 4,

  /**
   * @generated from enum value: PERMIT_SORT_PROJECT_NAME = 5;
   */
  PROJECT_NAME = 5,

  /**
   * @generated from enum value: PERMIT_SORT_CONTRACTOR_NAME = 6;
   */
  CONTRACTOR_NAME = 6,

  /**
   * @generated from enum value: PERMIT_SORT_TAX_LOCATION = 7;
   */
  TAX_LOCATION = 7,

  /**
   * @generated from enum value: PERMIT_SORT_CLIENT_COST = 8;
   */
  CLIENT_COST = 8,

  /**
   * @generated from enum value: PERMIT_SORT_REVIEW_FEES = 9;
   */
  REVIEW_FEES = 9,

  /**
   * @generated from enum value: PERMIT_SORT_JOB_NUMBER = 10;
   */
  JOB_NUMBER = 10,
}

/**
 * @generated from enum vmspdb.api.proto.v1.PermitSort
 */
export type PermitSortJson =
  | 'PERMIT_SORT_UNSPECIFIED'
  | 'PERMIT_SORT_PAYMENT_STATUS'
  | 'PERMIT_SORT_NOTES'
  | 'PERMIT_SORT_PERMIT_STATUS'
  | 'PERMIT_SORT_SUBMIT_STATUS'
  | 'PERMIT_SORT_PROJECT_NAME'
  | 'PERMIT_SORT_CONTRACTOR_NAME'
  | 'PERMIT_SORT_TAX_LOCATION'
  | 'PERMIT_SORT_CLIENT_COST'
  | 'PERMIT_SORT_REVIEW_FEES'
  | 'PERMIT_SORT_JOB_NUMBER';

/**
 * Describes the enum vmspdb.api.proto.v1.PermitSort.
 */
export const PermitSortSchema: GenEnum<PermitSort, PermitSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_project_permits, 2);

/**
 * @generated from service vmspdb.api.proto.v1.ProjectPermitTaskService
 */
export const ProjectPermitTaskService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectPermitTaskService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof ProjectPermitTaskServiceGetRequestSchema;
    output: typeof ProjectPermitTaskServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectPermitTaskService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof ProjectPermitTaskServiceUpdateRequestSchema;
    output: typeof ProjectPermitTaskServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectPermitTaskService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof ProjectPermitTaskServiceListRequestSchema;
    output: typeof ProjectPermitTaskServiceListResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_project_permits, 0);
